export default __webpack_public_path__ + "2da5c6321f29322413b54065f5738e64.webp";